import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { signOut } from "firebase/auth";
import { auth, db } from "./firebase-config";
import { doc, getDoc } from "firebase/firestore";
import Home from "./pages/Home";
import Library from "./pages/Library";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import StudentDashboard from "./pages/StudentDashboard";
import TeacherDashboard from "./pages/TeacherDashboard";
import QuestionnaireCreate from "./pages/QuestionnaireCreate";
import QuestionnaireView from "./pages/QuestionnaireView";
import QuestionnaireEdit from "./pages/QuestionnaireEdit";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import Chat from "./pages/Chat";
import ProfileEdit from "./pages/ProfileEdit";
import QuestionnaireDetail from "./pages/QuestionnaireDetail";
import "./style/NavBar.css";


function App() {
  const [isAuth, setIsAuth] = useState(sessionStorage.getItem("isAuth") === "true");
  const [role, setRole] = useState(sessionStorage.getItem("role") || null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);  // Control RWD switches

  useEffect(() => {
    const fetchUserRole = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userDocRef = doc(db, "Users", user.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();
        setRole(userData.role);
        localStorage.setItem("role", userData.role);
      }
    };

    fetchUserRole();
  }, []);

  useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged((user) => {
    if (!user && isAuth) {
      // User was logged in but now isn't (page refresh/tab close)
      setIsAuth(false);
      setRole(null);
      sessionStorage.removeItem("isAuth");
      sessionStorage.removeItem("role");
    }
  });

  return () => unsubscribe();
}, [isAuth]);

  const signUserOut = () => {
    signOut(auth).then(() => {
      sessionStorage.clear();
      setIsAuth(false);
      setRole(null);
      window.location.pathname = '/Login';
    });
    setShowDropdown(false);
    setIsMenuOpen(false);
  };

  const closeMobileMenu = () => {
    setShowDropdown(false);
    setIsMenuOpen(false);
  };

  return (
    <BrowserRouter>
      <nav className="navbar">
        <div className="nav-logo">
          <a href="/">
            <img src="/Images/Grouplet_LOGO.png" alt="Logo" className="logo-image" />
          </a>
        </div>

          {/* for small screen */}
          <button className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            ☰
          </button>
          
          <div className={`nav-container ${isMenuOpen ? "open" : ""}`}>
            {!isAuth ? (
              <>
                <Link to="/library" onClick={closeMobileMenu}> Library </Link>
                <Link to="/services" onClick={closeMobileMenu}> Services </Link>
                <Link to="/pricing" onClick={closeMobileMenu}> Pricing </Link>
                <Link to="/about" onClick={closeMobileMenu}> About Us </Link>
                <Link to="/Login" onClick={closeMobileMenu}> Login/Sign Up </Link>
                
              </>
            ) : (
              <>
                <Link to="/" onClick={closeMobileMenu}> Home </Link>
                {role === "Teacher" && <Link to="/TeacherDashboard" onClick={closeMobileMenu}> Dashboard </Link>}
                {role === "Student" && <Link to="/StudentDashboard" onClick={closeMobileMenu}> Dashboard </Link>}

                {role === "Teacher" && (
                  <Link to="/ViewQuestionnaire" onClick={closeMobileMenu}> Questionnaires </Link>
                )}
                <Link to="/Notifications" onClick={closeMobileMenu}> Notifications </Link>
                <Link to="/Settings" onClick={closeMobileMenu}> Settings </Link>
                <Link to="/Profile" onClick={closeMobileMenu}> Profile </Link>
                <Link to="/Chat" onClick={closeMobileMenu}> Chat </Link>
                <Link to="#" className="logout-btn" onClick={signUserOut}>
                  Log Out
                </Link>
              </>
            )}
          </div>
      </nav>
      
      <Routes>
        <Route path="/" element={<Home isAuth={isAuth} />} />
        <Route path="/library" element={<Library />} />
        <Route path="/services" element={<Services />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login setIsAuth={setIsAuth} setRole={setRole}/>} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/TeacherDashboard" element={<TeacherDashboard />} />
        <Route path="/StudentDashboard" element={<StudentDashboard />} />
        <Route path="/CreateQuestionnaire" element={<QuestionnaireCreate />} />
        <Route path="/Notifications" element={<Notifications />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/ViewQuestionnaire" element={<QuestionnaireView />} />
        <Route path="/EditQuestionnaire/:id" element={<QuestionnaireEdit />} />
        <Route path="/EditProfile" element={<ProfileEdit />} />
        <Route path="/Questionnaire/:id" element={<QuestionnaireDetail />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;